import { Place } from '@/types/google-maps.types';
import { toCitySlug } from '@/utils/formatters/city/to-city-slug.util';

export const KNOWN_CITY_PLACES = {
  'curitiba-pr': {
    placeId: 'ChIJ3bPNUVPj3JQRCejLuqVrL20',
    formattedAddress: 'Curitiba, PR, Brasil',
    latitude: -25.4372382,
    longitude: -49.2699727,
    types: ['locality', 'political'],
    city: 'Curitiba',
    state: 'PR',
  },
  'sao-paulo-sp': {
    placeId: 'ChIJ0WGkg4FEzpQRrlsz_whLqZs',
    formattedAddress: 'São Paulo, SP, Brasil',
    latitude: -23.5557714,
    longitude: -46.6395571,
    types: ['locality', 'political'],
    city: 'São Paulo',
    state: 'SP',
  },
  'florianopolis-sc': {
    placeId: 'ChIJ1zLGsk45J5URRscEagtVvIE',
    formattedAddress: 'Florianópolis, SC, Brasil',
    latitude: -27.5948036,
    longitude: -48.5569286,
    types: ['locality', 'political'],
    city: 'Florianópolis',
    state: 'SC',
  },
  'londrina-pr': {
    placeId: 'ChIJbVivV1pD65QRcfkUxqURrCM',
    formattedAddress: 'Londrina, PR, Brasil',
    latitude: -23.3197305,
    longitude: -51.1662008,
    types: ['locality', 'political'],
    city: 'Londrina',
    state: 'PR',
  },
  'maringa-pr': {
    placeId: 'ChIJ-QsrE9nQ7JQR6PC8YweXpEk',
    formattedAddress: 'Maringá, PR, Brasil',
    latitude: -23.4209686,
    longitude: -51.9330844,
    types: ['locality', 'political'],
    city: 'Maringá',
    state: 'PR',
  },
  'ponta-grossa-pr': {
    placeId: 'ChIJISMQX8Ya6JQR8bIpRub0sKw',
    formattedAddress: 'Ponta Grossa, PR, Brasil',
    latitude: -25.0995752,
    longitude: -50.1583959,
    types: ['locality', 'political'],
    city: 'Ponta Grossa',
    state: 'PR',
  },
  'osasco-sp': {
    placeId: 'ChIJB_KeWwj_zpQRTkyCTH3iIQ8',
    formattedAddress: 'Osasco, SP, Brasil',
    latitude: -23.5326334,
    longitude: -46.7915243,
    types: ['locality', 'political'],
    city: 'Osasco',
    state: 'SP',
  },
  'balneario-camboriu-sc': {
    placeId: 'ChIJrSrlwly22JQRxOut5vUEwC0',
    formattedAddress: 'Balneário Camboriú, SC, Brasil',
    latitude: -26.9979839,
    longitude: -48.63258,
    types: ['locality', 'political'],
    city: 'Balneário Camboriú',
    state: 'SC',
  },
  'cascavel-pr': {
    placeId: 'ChIJYU33xx7U85QRvF9a4OwyrOs',
    formattedAddress: 'Cascavel, PR, Brasil',
    latitude: -24.9541715,
    longitude: -53.480283,
    types: ['locality', 'political'],
    city: 'Cascavel',
    state: 'PR',
  },
  'joinville-sc': {
    placeId: 'ChIJN6uxnfOj3pQR-ulh8Z2YS7w',
    formattedAddress: 'Joinville, SC, Brasil',
    latitude: -26.3043758,
    longitude: -48.8463744,
    types: ['locality', 'political'],
    city: 'Joinville',
    state: 'SC',
  },
  'itajai-sc': {
    placeId: 'ChIJO2aUG2XM2JQRezBAlGEtb1A',
    formattedAddress: 'Itajaí, SC, Brasil',
    latitude: -26.9082859,
    longitude: -48.6775167,
    types: ['locality', 'political'],
    city: 'Itajaí',
    state: 'SC',
  },
  'foz-do-iguacu-pr': {
    placeId: 'ChIJQwpTruuQ9pQRUqnEtHOUlyE',
    formattedAddress: 'Foz do Iguaçu, PR, Brasil',
    latitude: -25.5163356,
    longitude: -54.5853764,
    types: ['locality', 'political'],
    city: 'Foz do Iguaçu',
    state: 'PR',
  },
  'camboriu-sc': {
    placeId: 'ChIJ-8VjtNq12JQRbSKy_JNmYRk',
    formattedAddress: 'Camboriú, SC, Brasil',
    latitude: -27.0217451,
    longitude: -48.6515664,
    types: ['locality', 'political'],
    city: 'Camboriú',
    state: 'SC',
  },
  'itapema-sc': {
    placeId: 'ChIJEwTa9Ayx2JQRXHfZmtAgHSM',
    formattedAddress: 'Itapema, SC, Brasil',
    latitude: -27.0909014,
    longitude: -48.6151468,
    types: ['locality', 'political'],
    city: 'Itapema',
    state: 'SC',
  },
  'sao-jose-dos-pinhais-pr': {
    placeId: 'ChIJc3mP0kn23JQRVtbCO71iF_U',
    formattedAddress: 'São José dos Pinhais, PR, Brasil',
    latitude: -25.5345818,
    longitude: -49.2032653,
    types: ['locality', 'political'],
    city: 'São José dos Pinhais',
    state: 'PR',
  },
  'colombo-pr': {
    placeId: 'ChIJX2Yvsxvo3JQRFbd4Dj96onE',
    formattedAddress: 'Colombo, PR, Brasil',
    latitude: -25.3644204,
    longitude: -49.1860165,
    types: ['locality', 'political'],
    city: 'Colombo',
    state: 'PR',
  },
} satisfies Record<string, Place>;

type KnownCitySlug = keyof typeof KNOWN_CITY_PLACES;

function isKnownCitySlug(slug: string): slug is KnownCitySlug {
  return Object.hasOwn(KNOWN_CITY_PLACES, slug);
}

export function findKnownCityPlace(city: string, state: string): Place | null {
  const slug = toCitySlug(city, state);

  return slug && isKnownCitySlug(slug) ? KNOWN_CITY_PLACES[slug] : null;
}
